(function () {
    'use strict';

    angular.module("imApp").factory("batchDeliveriesService", ['$ihttp', function ($ihttp) {
        let service = {
            getBatchDelivery: function (parms) {
                return $ihttp.post({
                    method: 897,
                    parameters: parms || {}
                });
            },
            listBatchDeliveryRelatedTo: function (parms) {
                return $ihttp.post({
                    method: 701,
                    parameters: parms || {}
                });
            }
        };

        return service;
    }]);
})();
